export const AI_CART_BUILDER_SESSION_STORAGE = 'aiCartBuilder'

export const AI_CHAT_INPUT_NAME = 'chat-input'

export const CART_DEALS_SUBLOCATION = 'cart_deals'

export const SWAP_DRAWER_SUBLOCATION = 'swap_product_drawer'
